import { Component, OnInit } from '@angular/core';
import { RecordsService } from '../services/records.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {

  constructor(public recordservice: RecordsService, public translate: TranslateService) {
    this.translate.onLangChange.subscribe(() => {
      this.getpaysedit();
  });
   }

  public authors: any;
  public editeurs: any;
  public traductors: any;
  public revisors: any;
  public matieres: any;
  public titles: any;
  public types: any;
  // public anneedition: any;
  // public listlangue: any;
  // public langcible: any;
  public paysedit: any;
  public curryear:number = new Date().getFullYear();
  public term: string = ' ';
  public type: string = 'all';
  public field: string = '';
  public cauthor: string = '';
  public ceditor: string = '';
  public ctraductor: string = '';
  public cdiscip: string = '';
  public cpays: string = '';
  public cannee: string = '';
  public records: any;
  // public clangsource: string = '';
  // public clangcible: string = '';

  ngOnInit(): void {
    this.getAuthors();
    this.getEditors();
    this.getTraductors();
    // this.getrevisors();
    this.getmatieres();
    this.getpaysedit();
    this.gettitles();
    this.getTypes();
    // this.getanneedition();
    // this.getlistlangue();
    // this.getlistlanguecible();

    this.recordservice.getData()
      .subscribe(
        data => {
          if(this.recordservice.term) this.term = this.recordservice.term; else this.term = '%20';
          // console.log(this.recordservice.term);
          
          this.type = this.recordservice.type;
          // console.log(this.recordservice.type);
          this.getAuthors();
          this.getEditors();
          this.getTraductors();
          // this.getrevisors();
          this.getmatieres();
          this.getpaysedit();
          this.gettitles();
          this.getTypes();
        }, err => {
          console.log(err);
      }
    )
  }

  getAuthors(){
    // console.log('http://trad.fondation.org.ma:8090/api/filter/author/'+this.term+'/'+this.type);
    this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/filter/author/'+this.term+'/'+this.type+ '/'+ this.recordservice.shs + '/' + this.recordservice.lmg)
    .subscribe(data => {
      this.authors = data;
    }, err =>{
      console.log(err);
    });
  }

  searchAuthor(value) {
    // console.log('http://trad.fondation.org.ma:8090/api/filter/author_'+this.translate.currentLang+'/'+this.term+'/'+this.type+'/'+value);
    this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/filter/author/'+this.term+'/'+this.type + '/'+ this.recordservice.shs + '/' + this.recordservice.lmg +'/'+ value)
    .subscribe(data => {
      this.authors = data;
    }, err =>{
      console.log(err);
    });
  }

  getEditors(){
    this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/filter/editeur/'+this.term+'/'+this.type+ '/'+ this.recordservice.shs + '/' + this.recordservice.lmg)
    .subscribe(data => {
      this.editeurs = data;
    }, err =>{
      console.log(err);
    });
  }

  getTraductors(){
    this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/filter/traducteur/'+this.term+'/'+this.type+ '/'+ this.recordservice.shs + '/' + this.recordservice.lmg)
    .subscribe(data => {
      this.traductors = data;
    }, err =>{
      console.log(err);
    });
  }

  searchTrad(value){
    this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/filter/traducteur/'+this.term+'/'+this.type+ '/'+ this.recordservice.shs + '/' + this.recordservice.lmg+'/'+value)
    .subscribe(data => {
      this.traductors = data;
    }, err =>{
      console.log(err);
    });
  }

  getmatieres(){
    this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/filter/matiere/'+ this.recordservice.shs + '/' + this.recordservice.lmg)
    .subscribe(data => {
      this.matieres = data;
    }, err =>{
      console.log(err);
    });
  }
  
  getpaysedit(){
    this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/filter/paysedition/' +this.term+'/'+this.type+ '/'+ this.recordservice.shs + '/' + this.recordservice.lmg + '/%20/'+ this.translate.currentLang)
    .subscribe(data => {
      this.paysedit = data;
    }, err =>{
      console.log(err);
    });
  }
  
  gettitles(){
    this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/filter/titleoriginal/'+this.term+'/'+this.type+ '/'+ this.recordservice.shs + '/' + this.recordservice.lmg)
    .subscribe(data => {
      this.titles = data;
    }, err =>{
      console.log(err);
    });
  }

    
  getTypes(){
    // console.log('http://trad.fondation.org.ma:8090/api/filter/type/'+this.term+'/'+this.type+ '/'+ this.recordservice.shs + '/' + this.recordservice.lmg);
    
    this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/filter/type/ /'+this.type+ '/'+ this.recordservice.shs + '/' + this.recordservice.lmg)
    .subscribe(data => {
      this.types = data;
    }, err =>{
      console.log(err);
    });
    
    // this.recordservice.data.subscribe(d => {
      
    //   let types: Array<any> = new Array;
    //   let records = d.data;
    //   records.map((r: any) => { 
    //     console.log(r.type);
        
    //     if(r.type) {
    //       if(!types.some((t: any) => t.name == r.type)) types.push({name: r.type, y:1 })
    //       else { let i = types.findIndex(x => x.name === r.type); types[i].y++;}
    //     }
    //   });
      
    // this.types = types;
    // });
  }

  Getsearch(term: string, type: string) {
    this.term=term;
    this.field=type;
    this.recordservice.advanced = 'false';
    this.recordservice.getRecordsByterm(term, type, 0);
    // console.log(this.term + ' - ' + this.type);
  }

  
  reset() {
    this.type='all';
    this.field='';
    this.recordservice.type = 'all';
    this.recordservice.getRecordsByterm('', this.recordservice.type, 0);
  }

  // pluslimit(type) {
  //   if(type==='author') { this.limita +=10; this.getAuthors(); }
  //   else if(type==='traducteur') { this.limitt +=10; this.getTraductors(); }
  //   else if(type==='editeur') { this.limite +=10; this.getEditors(); }
  //   else if(type==='paysedition') { this.limitp +=10; this.getpaysedit(); }
  //   else if(type==='matiere') { this.limitm +=10; this.getmatieres(); }
  //   else if(type==='matietitleoriginalre') { this.limittl +=10; this.gettitles(); }
  // }
  // getrevisors(){
  //   this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/reviseurs/'+this.term+'/'+this.type)
  //   .subscribe(data => {
  //     this.revisors = data;
  //   }, err =>{
  //     console.log(err);
  //   });
  // }

  // getlistlangue(){
  //   this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/listlangue')
  //   .subscribe(data => {
  //     this.listlangue = data;
  //   }, err =>{
  //     console.log(err);
  //   });
  // }

  // getlistlanguecible(){
  //   this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/listlanguecible')
  //   .subscribe(data => {
  //     this.langcible = data;
  //   }, err =>{
  //     console.log(err);
  //   });
  // }

  // getanneedition(){
  //   this.recordservice.getFilters('http://trad.fondation.org.ma:8090/api/anneedition')
  //   .subscribe(data => {
  //     this.anneedition = data;
  //   }, err =>{
  //     console.log(err);
  //   });
  // }

  // Getsearch(term: string, type: string) {
  //   this.term=term;
  //   this.type=type;
  //   this.recordservice.advanced = 'true';
  //   if(this.type=='author') { this.recordservice.auteur = this.term; this.recordservice.first="1600"; this.recordservice.end = this.curryear.toString();}
  //   this.recordservice.getRecordsByterm('', 'expression', 0);
  // }

}
